__turbopack_context__.v({
  "legend": "index-module-scss-module__8XK1tG__legend",
  "maipActiveFilters": "index-module-scss-module__8XK1tG__maipActiveFilters",
  "maipContainer": "index-module-scss-module__8XK1tG__maipContainer",
  "maipControls": "index-module-scss-module__8XK1tG__maipControls",
  "maipHeader": "index-module-scss-module__8XK1tG__maipHeader",
  "maipLink": "index-module-scss-module__8XK1tG__maipLink",
  "maipMastHead": "index-module-scss-module__8XK1tG__maipMastHead",
  "maipNoResultsTitle": "index-module-scss-module__8XK1tG__maipNoResultsTitle",
  "maipResults": "index-module-scss-module__8XK1tG__maipResults",
  "maipSearch": "index-module-scss-module__8XK1tG__maipSearch",
});
